import React from 'react'
import { Route, Navigate, Routes } from 'react-router-dom'
import Layout from './Layout/Layout'
import NetworkDetector from '../components/Hoc/NetworkDetector'
import Login from '../pages/login/Login'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
const App = () => {
  return (
    <>
      <ToastContainer position='top-right' autoClose={3000} />
      <Routes>
        <Route path='/' element={<Navigate to='/login' />} />
        <Route path='/app/*' element={<PrivateRoute component={Layout} />} />
        <Route path='/login' element={<PublicRoute component={Login} />} />
      </Routes>
    </>
  )
}

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = localStorage.getItem('accessToken')
  return isAuthenticated ? <Component {...rest} /> : <Navigate to='/login' />
}

const PublicRoute = ({ component: Component, ...rest }) => {
  return <Component {...rest} />
}

export default NetworkDetector(App)
